import { canUseShopping } from '@/lib/shoppingLists/access'

// The meal planner is for home cooks (general accounts) only, decided the same way as shopping
// lists: by the account the person is logged into right now, not by whether they own a business.
export const canUseMealPlanner = canUseShopping
